import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import $ from "jquery";
// var Bloodhound = require("react-bootstrap-typeahead").Bloodhound;

$.typeahead = require("typeahead.js");
var Bloodhound = require("typeahead.js/dist/bloodhound.js");

export class OMSTwitterGeoAutocomplete extends React.Component {
  static propTypes = {
      id: PropTypes.string,
      name: PropTypes.string,
      value: PropTypes.string,
      style: PropTypes.object,
      country: PropTypes.string,
      onChange: PropTypes.func
  };

  static defaultProps = {
      id: '',
      name: '',
      country: 'South Africa',
      value: null,
      style: null,
      onChange: undefined
  };

  state = {
      locationid: ''
  };

  componentDidMount() {
      this.doMapTypeaheadBind();
  }

  doMapTypeaheadBind = () => {

      var AUTOCOMPLETION_URL = 'https://autocomplete.geocoder.api.here.com/6.2/suggest.json';

      var APPLICATION_ID = 'fF44c0Lf6GzCoeb27d64'
      var APPLICATION_CODE = 'vrzOQWmJLkGyzTMK74n12w'
      //var APPLICATION_ID = '7oM7HUWgX8ouW2Ehe0m2';
      //var APPLICATION_CODE = 'T7OsnFL0cXetB-J-VbDhrQ';

      var params = '?' + 'query=%QUERY' +   // The search text which is the basis of the query
          '&maxresults=50' +  // The upper limit the for number of suggestions to be included
          // in the response.  Default is set to 5.
          '&language=EN' +
          '&country=%COUNTRY' +
          '&app_id=' + APPLICATION_ID +
          '&app_code=' + APPLICATION_CODE;

      var bestPictures = new Bloodhound({
          datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
          queryTokenizer: Bloodhound.tokenizers.whitespace,
          remote: {
              url: AUTOCOMPLETION_URL + params,
              replace: function (url, query) {
                  var COUNTRY = document.getElementById('hdnGeoAutocompleteC').value;
                  if (COUNTRY == "Namibia")
                      COUNTRY = "NAM";
                  else if (COUNTRY == "Cyprus")
                      COUNTRY = "CYP";
                  else if(COUNTRY == "Seychelles")
                      COUNTRY = "SYC ";
                  else
                      COUNTRY = "ZAF"

                  return url.replace('%QUERY', encodeURIComponent(query)).replace('%COUNTRY', COUNTRY);
              },
              filter: function (response) {
                  //console.log("After data is obtained, suggestions:", response);
                  const filteredData=
                   $.map(response.suggestions, function (item) {
                      if (item !== undefined) {
                          var arr = item.label.split(',');
                          arr.reverse();
                          for (var j = 0; j < arr.length; j++) {
                              arr[j] = arr[j].trim();
                          }
                          item.displayText = arr.join(', ');
                      }
                      return item;
                  });
                  //console.log("After data is filtered, filteredData:", filteredData);
                  return filteredData;
              },
              wildcard: '%QUERY',
              limit: 10,
          }
      });

      $("#" + this.props.id).typeahead(null, {
          name: this.props.id,
          display: 'displayText',
          source: bestPictures,
          limit:8,
          templates: {
              suggestion: function (data) {
                  //console.log("After data is obtained,data:", data);
                  var arr = data.displayText.split(',');
                  return '<span><i class="fa fa-map-marker" aria-hidden="true"></i>&nbsp;&nbsp;<strong>' + arr[0] + '</strong><small>,' + arr.slice(1).join(',') + '</small></span>';
              }
          }
      });

      $("#" + this.props.id).bind('typeahead:select', function (ev, suggestion) {

          if (this.state.locationid != suggestion.locationId) {
              this.setState({ locationid: suggestion.locationId });
              if (this.props.onChange !== undefined)
                  this.props.onChange(suggestion.locationId);
          }
      }.bind(this));
  };

  render() {
      return (
          <div className="dropdown">
              <input type="hidden" data-id={this.props.id} id="hdnGeoAutocompleteC" name="hdnGeoAutocompleteC" value={this.props.country} />
              <input type="text" id={this.props.id} name={this.props.name} autoComplete="off" placeholder="Please identify the listing on the map, start entering the address" className="form-control" />
          </div>
      )
  }
}
